export default __webpack_public_path__ + "static/media/VD-3000.e8191bff.png";